import { create } from "zustand";

export type AutomationStateFilter = "all" | "enabled" | "disabled" | "failed";
export type AutomationScheduleFilter = "all" | "manual" | "scheduled";
export type AutomationSortBy = "attention" | "name" | "updated" | "last_run";

type AutomationsUiState = {
  search: string;
  stateFilter: AutomationStateFilter;
  deliveryFilter: string;
  scheduleFilter: AutomationScheduleFilter;
  sortBy: AutomationSortBy;
  setSearch: (value: string) => void;
  setStateFilter: (value: AutomationStateFilter) => void;
  setDeliveryFilter: (value: string) => void;
  setScheduleFilter: (value: AutomationScheduleFilter) => void;
  setSortBy: (value: AutomationSortBy) => void;
  resetFilters: () => void;
};

const DEFAULTS = {
  search: "",
  stateFilter: "all" as const,
  deliveryFilter: "all",
  scheduleFilter: "all" as const,
  sortBy: "attention" as const,
};

export const useAutomationsUiStore = create<AutomationsUiState>((set) => ({
  ...DEFAULTS,
  setSearch: (value) => set({ search: value }),
  setStateFilter: (value) => set({ stateFilter: value }),
  setDeliveryFilter: (value) => set({ deliveryFilter: value }),
  setScheduleFilter: (value) => set({ scheduleFilter: value }),
  setSortBy: (value) => set({ sortBy: value }),
  resetFilters: () => set(DEFAULTS),
}));
